const LOCALES = ["sv", "en"];

export function normalizePath(path) {
  const segments = path.split("/").filter(Boolean);
  if (LOCALES.includes(segments[0])) {
    return "/" + segments.slice(1).join("/");
  }

  return path;
}

export const routeColorMap = [
  { match: (path) => normalizePath(path) === "/", color: "bg-[#B3594D]" },
  { match: (path) => normalizePath(path) === "/privacy-policy", color: "bg-[#B3594D]" },
  { match: (path) => normalizePath(path).startsWith("/aboutus"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/medarbetare"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/styrelse"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/agare"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/article"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/blog"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/fakturakop"), color: "bg-[#95C3A8]" },
  { match: (path) => normalizePath(path).startsWith("/faq"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/foretagslan"), color: "bg-[#B3594D]" },
  { match: (path) => normalizePath(path).startsWith("/inkasso"), color: "bg-[#B3D1E3]" },
  { match: (path) => normalizePath(path).startsWith("/onboarding"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/csr"), color: "bg-[#5C2483]" },
  { match: (path) => normalizePath(path).startsWith("/fabrikens-vanner"), color: "bg-[#5C2483]" }
];

export const arrowColor = [
  { match: (path) => normalizePath(path) === "/", color: "#B3594D" },
  { match: (path) => normalizePath(path) === "/privacy-policy", color: "#B3594D" },
  { match: (path) => normalizePath(path).startsWith("/aboutus"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/medarbetare"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/styrelse"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/agare"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/article"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/blog"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/fakturakop"), color: "#ECF4F8" },
  { match: (path) => normalizePath(path).startsWith("/faq"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/foretagslan"), color: "#B3594D" },
  { match: (path) => normalizePath(path).startsWith("/inkasso"), color: "#ECF4F8" },
  { match: (path) => normalizePath(path).startsWith("/onboarding"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/blog"), color: "#5C2483" },
  { match: (path) => normalizePath(path).startsWith("/fabrikens-vanner"), color: "#5C2483" }
];
